
import { useEffect, useState } from "react"
import { useConfirmationStore } from "@/lib/stores/confirmation-store"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

export function GlobalConfirmationDialog() {
  // Use local state to prevent direct binding to the store
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  // Get values from the store
  const store = useConfirmationStore()

  // Sync local state with store
  useEffect(() => {
    setIsOpen(store.isOpen)
    setIsLoading(store.isLoading)
  }, [store.isOpen, store.isLoading])

  // Handle close
  const handleClose = () => {
    store.close()
  }

  // Handle confirm
  const handleConfirm = async () => {
    try {
      setIsLoading(true)
      await store.onConfirm()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) handleClose()
      }}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{store.title}</DialogTitle>
          <DialogDescription>{store.message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose} disabled={isLoading}>
            {store.cancelLabel}
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isLoading}
            variant={store.variant}
            className={
              store.variant === "destructive"
                ? "bg-destructive text-destructive-foreground hover:bg-destructive/90"
                : ""
            }
          >
            {isLoading ? "Loading..." : store.confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
